import React, { FunctionComponent, ComponentProps } from 'react';
import { useContext } from 'react';
import { SynchronizationStatusContext } from '../../context/SynchronizationStatusContext';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import { Icon } from '../../misc/Icon/Icon';
import styles from './SyncIcon.module.css';

export type SyncIconProps = ComponentProps<'span'>;

export const SyncIcon: FunctionComponent<SyncIconProps> = React.memo(
  (props) => {
    const { className, ...remainingProps } = prepareProps({
      props,
      ignoreChildren: true
    });
    const synchronizationStatus = useContext(SynchronizationStatusContext);
    const hasFailedItems = synchronizationStatus.itemsToSynchronizeInfos.some(
      (info) => info.failed
    );

    return (
      <span
        {...remainingProps}
        className={classes(
          className,
          styles.wrapper,
          hasFailedItems ? styles.failed : null
        )}
      >
        <Icon
          name="sync-alt"
          className={
            synchronizationStatus.inProgress ? styles.animatedIcon : undefined
          }
        ></Icon>
        {synchronizationStatus.itemsToSynchronizeInfos.length ===
        0 ? undefined : (
          <span
            className={styles.itemCountBadge}
            data-testid="SyncIcon.itemCountBadge"
          >
            {synchronizationStatus.itemsToSynchronizeInfos.length}
          </span>
        )}
      </span>
    );
  }
);
